import React from 'react';
import { CardItem } from '../../../../../theme/components';
import { useAppSelector } from '../../../../../redux/store.model';
import { getAlarmActiveBySelector } from '../../../../../redux/incident/selectors/getAlarmActiveBySelector';
import GroupModel from '../../../../../redux/groups/api/GroupModel';
import { getPolyglot } from '../../../../../i18n';
import { DeviceGroupIcon } from '../../../../../theme/icons';
import { useNavigate } from 'react-router-dom';
import { GroupActionsGrid } from './GroupActions/GroupActions';
import { Group } from '../../../../../redux/groups/api/group.model';
import { getFeatureToggle } from '../../../../../featureToggle';

interface GroupCardGridProps {
  group: Group;
  showImage?: boolean;
  moduleSelected: string | '';
}
function GroupCardGrid(props: GroupCardGridProps) {
  const { group, showImage = true } = props;
  const polyglot = getPolyglot();
  const navigate = useNavigate();

  const featureToggle = useAppSelector(getFeatureToggle);
  /* TODO: Update when there is a better product decision on stores list view */
  const isFreshWatch =
    featureToggle?.styledComponentsVariants === 'fresh-watch';
  const { data: alarmsActive } = useAppSelector((state) =>
    getAlarmActiveBySelector(state, {
      groupId: group.id,
    })
  );
  const openDeviceDetail = () => {
    const url = `/devicemanager/group/${group.id}`;
    navigate(url);
  };
  const onNavigateToMerchandiser = () => {
    navigate(`/merchandiser/${group?.id}`);
  };

  return (
    <CardItem
      key={group.id}
      name={group.name}
      // subTitle={GroupModel.getGroupSubtitles(group)}
      altIcon={polyglot.t('group.icon')}
      iconURL={group.iconURL ?? undefined}
      defaultIcon={<DeviceGroupIcon height={'150px'} />}
      onClick={isFreshWatch ? onNavigateToMerchandiser : openDeviceDetail}
      error={alarmsActive.length > 0}
      buttonsActions={<GroupActionsGrid group={group} />}
      showImage={showImage}
    />
  );
}

export default GroupCardGrid;
